import React from "react";
import SurveyResultsComponent from "../../components/SurveyResults/SurveyResults.component";
import IPage from "../../interfaces/page"

const SurveyResultsPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <SurveyResultsComponent></SurveyResultsComponent>;
};

export default SurveyResultsPage;
